import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.set');
import { OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-set',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.set/view.scss */
:host {
  display: block;
  height: 100%;
}

.set-page {
  background: #f8fafc;
  font-family: "SUIT", -apple-system, sans-serif;
}

.sidebar {
  width: 260px;
  min-width: 260px;
  background: #1e3a5f;
  color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.sidebar-header {
  padding: 24px 20px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 12px;
}

.sidebar-logo {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.sidebar-title-main {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.sidebar-title-sub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 2px;
}

.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  padding: 12px 10px;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 2px;
  text-decoration: none;
}
.sidebar-nav-item i {
  width: 16px;
  text-align: center;
  font-size: 12px;
}
.sidebar-nav-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}
.sidebar-nav-item.active {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  font-weight: 600;
}

.sidebar-footer {
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-stat {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 6px;
}

.stat-label {
  color: rgba(255, 255, 255, 0.5);
}

.stat-value {
  font-weight: 600;
}

.sidebar-progress {
  height: 4px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
  overflow: hidden;
}

.sidebar-progress-bar {
  height: 100%;
  background: #3b82f6;
  border-radius: 2px;
  transition: width 0.3s;
}

.main-content {
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow: hidden;
}

.content-scroll {
  height: 100%;
  overflow-y: auto;
  padding: 32px 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.hero-banner {
  position: relative;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a8e 50%, #1a4971 100%);
  border-radius: 12px;
  padding: 48px 40px 44px;
  margin-bottom: 28px;
  color: white;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  gap: 40px;
}
.hero-banner::before {
  content: "";
  position: absolute;
  top: -40%;
  right: -10%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.06) 0%, transparent 70%);
  pointer-events: none;
}
.hero-banner::after {
  content: "";
  position: absolute;
  bottom: -30%;
  left: 10%;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.12) 0%, transparent 70%);
  pointer-events: none;
}

.hero-left {
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.hero-right {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 16px;
  backdrop-filter: blur(4px);
}
.hero-badge i {
  font-size: 10px;
  opacity: 0.8;
}

.hero-title {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.2;
  margin: 0 0 10px;
}

.hero-desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
  margin: 0 0 28px;
  max-width: 640px;
}

.hero-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 12px;
  backdrop-filter: blur(4px);
}

.hero-stat-item {
  padding: 12px 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
}

.hero-stat-value {
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 4px;
}

.hero-stat-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.section-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  margin-bottom: 28px;
  overflow: hidden;
}

.section-header {
  padding: 28px 32px 16px;
  border-bottom: 1px solid #e2e8f0;
  position: relative;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #1e3a5f;
  color: white;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 10px;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.02em;
}

.section-subtitle {
  font-size: 15px;
  color: #64748b;
  margin: 4px 0 0;
}

.section-body {
  padding: 28px 32px 32px;
}

.subsection-title {
  font-size: 16px;
  font-weight: 600;
  color: #334155;
  margin: 0 0 12px;
}

.overview-card-models {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 20px 24px;
}

.overview-card-models-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.model-detail-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
}

.model-detail-tag {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #ccc;
  border-radius: 8px;
  transition: border-color 0.15s;
  min-width: 0;
}
.model-detail-tag:hover {
  border-color: #94a3b8;
}

.model-detail-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.model-detail-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.model-detail-meta {
  display: flex;
  align-items: center;
  gap: 3px;
  padding-left: 14px;
  min-width: 0;
}

.model-detail-vendor {
  font-size: 10px;
  color: #64748b;
  white-space: nowrap;
}

.model-detail-sep {
  font-size: 9px;
  color: #cbd5e1;
}

.model-detail-tier {
  font-size: 10px;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

.model-detail-price {
  font-size: 9px;
  color: #94a3b8;
  font-family: "Menlo", monospace;
  white-space: nowrap;
}

.overview-detail-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 20px 24px;
}

.overview-detail-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.dpi-icon {
  background: #faf5ff !important;
  color: #8b5cf6 !important;
}

.overview-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.overview-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.overview-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-icon {
  width: 36px;
  height: 36px;
  background: #eff6ff;
  color: #3b82f6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.card-number {
  font-size: 28px;
  font-weight: 700;
  color: #1e3a5f;
  line-height: 1;
}

.card-label {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.card-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tag-vendor, .tag-dpi, .tag-file {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #475569;
}

.tag-vendor {
  border-left: 2px solid #ccc;
}

.dpi-detail-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.dpi-detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dpi-detail-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dpi-value-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  padding: 2px 8px;
  border-radius: 4px;
  color: white;
  font-size: 11px;
  font-weight: 700;
  font-family: "Menlo", monospace;
}

.dpi-detail-label {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  flex: 1;
}

.dpi-detail-factor {
  font-size: 10px;
  color: #64748b;
  font-family: "Menlo", monospace;
}

.dpi-detail-bar-wrap {
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  overflow: hidden;
}

.dpi-detail-bar {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s;
  opacity: 0.7;
}

.dpi-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dpi-label-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  color: white;
  font-size: 11px;
  font-weight: 500;
}

.axis-toggle {
  display: flex;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.axis-btn {
  display: flex;
  align-items: center;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  background: white;
  border: none;
  cursor: pointer;
  transition: all 0.15s;
}
.axis-btn:not(:last-child) {
  border-right: 1px solid #e2e8f0;
}
.axis-btn:hover {
  background: #f8fafc;
  color: #334155;
}
.axis-btn.active {
  background: #1e3a5f;
  color: white;
}

.pdf-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.pdf-info-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.15s;
}
.pdf-info-card:hover {
  border-color: #94a3b8;
}

.pdf-info-icon {
  width: 40px;
  height: 40px;
  background: #fef3c7;
  color: #d97706;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.pdf-info-body {
  flex: 1;
  min-width: 0;
}

.pdf-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.pdf-info-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.pdf-view-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #475569;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
}
.pdf-view-btn i {
  font-size: 10px;
}
.pdf-view-btn:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: #eff6ff;
}

.pdf-info-type {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 6px;
}

.pdf-type-badge {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #dbeafe;
  color: #1e40af;
  font-weight: 500;
}

.pdf-stat-badge {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #64748b;
  font-family: "Menlo", monospace;
}

.pdf-info-desc {
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
  margin-bottom: 8px;
}

.pdf-info-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.pdf-tag {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #ecfdf5;
  color: #065f46;
  font-weight: 500;
  border: 1px solid #d1fae5;
}

.table-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}
.data-table thead {
  background: #f8fafc;
}
.data-table thead th {
  padding: 10px 14px;
  font-weight: 600;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.data-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.1s;
}
.data-table tbody tr:hover {
  background: #f8fafc;
}
.data-table tbody tr:last-child {
  border-bottom: none;
}
.data-table tbody td {
  padding: 10px 14px;
  color: #334155;
}
.data-table.compact {
  font-size: 12px;
}
.data-table.compact td, .data-table.compact th {
  padding: 7px 10px;
}

.model-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tier-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #475569;
}

.file-tabs {
  display: flex;
  gap: 8px;
}

.file-tab {
  padding: 9px 20px;
  font-size: 15px;
  color: #475569;
  border: 1px solid #d1d5db;
  background: white;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.15s;
  font-weight: 500;
}
.file-tab:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: #eff6ff;
}
.file-tab.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.table-legend {
  display: flex;
  gap: 20px;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
}

.legend-icon {
  font-size: 11px;
}
.legend-icon.legend-icon-quality {
  color: #3b82f6;
}
.legend-icon.legend-icon-cost {
  color: #f59e0b;
}
.legend-icon.legend-icon-time {
  color: #10b981;
}

.unified-table .model-col {
  min-width: 120px;
  white-space: nowrap;
}
.unified-table thead th {
  padding: 10px 8px;
}
.unified-table tbody td {
  padding: 6px 8px;
  vertical-align: middle;
}

.cell-tri {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 4px 0;
  min-width: 130px;
}

.cell-tri-row {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 0;
}

.cell-tri-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0 4px;
}

.cell-tri-sub {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 0 1px 19px;
  font-family: "Menlo", monospace;
  letter-spacing: -0.3px;
}

.tri-icon {
  font-size: 10px;
  width: 14px;
  text-align: center;
  flex-shrink: 0;
}
.tri-icon.tri-quality {
  color: #3b82f6;
}
.tri-icon.tri-cost {
  color: #f59e0b;
}
.tri-icon.tri-time {
  color: #10b981;
}

.tri-label {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
  min-width: 22px;
  flex-shrink: 0;
}

.quality-pill {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}

.cell-tri-cost {
  font-size: 11px;
  color: #475569;
  font-family: "Menlo", monospace;
}

.cell-tri-time {
  font-size: 11px;
  color: #475569;
}

.summary-weights {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 20px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.summary-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.preset-chip {
  padding: 8px 18px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.preset-chip:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.12);
}
.preset-chip.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.3);
}

.summary-sliders {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.summary-slider-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.summary-slider-item input[type=range] {
  width: 100px;
  height: 3px;
  -webkit-appearance: none;
  appearance: none;
  background: #e2e8f0;
  border-radius: 2px;
  outline: none;
}
.summary-slider-item input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #3b82f6;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.summary-slider-label {
  font-size: 12px;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 3px;
  min-width: 48px;
}
.summary-slider-label i {
  font-size: 10px;
}

.summary-slider-val {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  min-width: 30px;
  text-align: right;
}

.summary-slider-sum {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  margin-left: 4px;
}
.summary-slider-sum.invalid {
  color: #dc2626;
  font-weight: 600;
}

.top-picks-row {
  display: flex;
  gap: 12px;
}

.top-pick-mini {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.15s;
}
.top-pick-mini.rank-1 {
  border-color: #fbbf24;
  background: #fffbeb;
}
.top-pick-mini.rank-2 {
  border-color: #94a3b8;
  background: #f8fafc;
}
.top-pick-mini.rank-3 {
  border-color: #d97706;
  background: #fffbeb;
}

.top-pick-mini-rank {
  font-size: 22px;
  flex-shrink: 0;
}

.top-pick-mini-info {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.top-pick-mini-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e3a5f;
  white-space: nowrap;
}

.top-pick-mini-dpi {
  font-size: 10px;
  color: #64748b;
  background: #f1f5f9;
  padding: 1px 6px;
  border-radius: 3px;
  white-space: nowrap;
}

.top-pick-mini-score {
  font-size: 18px;
  font-weight: 700;
  color: #3b82f6;
  flex-shrink: 0;
}

.top-pick-mini-details {
  display: flex;
  flex-direction: column;
  gap: 1px;
  font-size: 10px;
  color: #64748b;
  flex-shrink: 0;
}
.top-pick-mini-details i {
  font-size: 9px;
}

.score-matrix .model-col {
  min-width: 120px;
  white-space: nowrap;
}
.score-matrix thead th {
  padding: 10px 8px;
}
.score-matrix tbody td {
  padding: 4px 6px;
  vertical-align: middle;
}

.score-matrix-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  min-width: 52px;
  transition: transform 0.1s;
}
.score-matrix-cell:hover {
  transform: scale(1.05);
}

.formula-block {
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.formula-title {
  font-size: 17px;
  font-weight: 600;
  color: #1e3a5f;
  margin: 0 0 8px;
}

.formula-desc {
  font-size: 15px;
  color: #64748b;
  margin-bottom: 12px;
}

.formula-box {
  background: #0f172a;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 12px;
}

.formula-code {
  font-family: "Menlo", "Courier New", monospace;
  font-size: 14px;
  color: #93c5fd;
  line-height: 1.6;
}

.formula-note {
  font-size: 14px;
  color: #64748b;
  line-height: 1.7;
  padding-left: 4px;
}

.verdict-card {
  position: relative;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%);
  border-radius: 12px;
  margin-bottom: 28px;
  overflow: hidden;
  color: white;
}
.verdict-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  background: radial-gradient(ellipse at 80% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
  pointer-events: none;
}

.verdict-inner {
  display: flex;
  align-items: stretch;
  gap: 40px;
  padding: 40px;
  position: relative;
  z-index: 1;
}

.verdict-left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.verdict-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 220px;
}

.verdict-label-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.verdict-icon {
  width: 36px;
  height: 36px;
  background: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #60a5fa;
}

.verdict-label {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #60a5fa;
}

.verdict-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0 0 14px;
  color: white;
}

.verdict-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.7;
  margin: 0;
}
.verdict-desc strong {
  color: #93c5fd;
  font-weight: 600;
}

.verdict-pick-card {
  flex: 1;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 18px 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: border-color 0.15s;
}
.verdict-pick-card.pick-model {
  border-left: 3px solid #60a5fa;
}
.verdict-pick-card.pick-dpi {
  border-left: 3px solid #a78bfa;
}

.verdict-pick-header {
  display: flex;
  align-items: center;
}

.verdict-pick-tag {
  font-size: 10px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.verdict-pick-value {
  font-size: 20px;
  font-weight: 800;
  color: white;
  line-height: 1.2;
}

.verdict-pick-meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.verdict-pick-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}
.verdict-pick-chip i {
  font-size: 9px;
}

.analysis-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.analysis-card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

.analysis-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.analysis-card-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}
.analysis-card-icon.icon-model {
  background: #eff6ff;
  color: #3b82f6;
}
.analysis-card-icon.icon-dpi {
  background: #faf5ff;
  color: #8b5cf6;
}

.analysis-card-title {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
}

.analysis-card-body {
  padding: 20px;
}

.analysis-finding {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 10px;
}
.analysis-finding:last-child {
  margin-bottom: 0;
}

.analysis-finding-icon {
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 2px;
}

.analysis-finding-body {
  flex: 1;
  min-width: 0;
}

.analysis-finding-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.analysis-finding-desc {
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
}

.analysis-data-highlight {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #dbeafe;
  color: #1e40af;
  font-size: 11px;
  font-weight: 600;
  font-family: "Menlo", monospace;
}

.analysis-data-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.analysis-conclusion {
  margin-top: 16px;
  padding: 14px 16px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  font-size: 14px;
  color: #92400e;
  line-height: 1.7;
}
.analysis-conclusion strong {
  color: #78350f;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  text-align: center;
}

.page-footer {
  text-align: center;
  padding: 24px 0 32px;
  font-size: 12px;
  color: #94a3b8;
}

.pdf-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.15s ease;
}

.pdf-modal {
  width: 90vw;
  height: 90vh;
  max-width: 1200px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: scaleIn 0.15s ease;
}

.pdf-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  flex-shrink: 0;
}

.pdf-modal-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}
.pdf-modal-title i {
  color: #dc2626;
}

.pdf-modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  font-size: 14px;
  transition: all 0.15s;
}
.pdf-modal-close:hover {
  background: #cbd5e1;
  color: #1e293b;
}

.pdf-modal-iframe {
  flex: 1;
  width: 100%;
  border: none;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}`],
})
export class PageSetComponent implements OnInit {

    // ── 설정 ──
    public models: string[] = [];
    public dpis: number[] = [];
    public files: any[] = [];
    public pricing: any = {};

    // ── 데이터 ──
    public results: any = {};
    public status: any = { total: 0, done: 0, status: {} };

    // ── UI 상태 ──
    public activeSection: string = 'overview';
    public activeFileIndex: number = 0;
    public loading: boolean = true;
    public compareAxis: string = 'model'; // 'model' (모델행×DPI열) | 'dpi' (DPI행×모델열)
    public matrixAxis: string = 'model';

    // ── PDF 모달 ──
    public pdfModalOpen: boolean = false;
    public pdfModalUrl: SafeResourceUrl = '';
    public pdfModalLabel: string = '';

    // ── 가중치 (합계 100) ──
    public weightQuality: number = 50;
    public weightCost: number = 30;
    public weightTime: number = 20;

    public weightPresets = [
        { label: '균형 (50/30/20)', q: 50, c: 30, t: 20 },
        { label: '품질 중심 (70/15/15)', q: 70, c: 15, t: 15 },
        { label: '품질 극대 (90/5/5)', q: 90, c: 5, t: 5 },
        { label: '비용 중심 (20/60/20)', q: 20, c: 60, t: 20 },
        { label: '속도 중심 (20/20/60)', q: 20, c: 20, t: 60 },
        { label: '품질만 (100/0/0)', q: 100, c: 0, t: 0 },
    ];

    public sections = [
        { id: 'overview', label: '개요', icon: 'fa-solid fa-house' },
        { id: 'file-compare', label: '파일별 비교', icon: 'fa-solid fa-file-lines' },
        { id: 'summary', label: '종합 결과', icon: 'fa-solid fa-table' },
        { id: 'verdict', label: '총평', icon: 'fa-solid fa-bullseye' },
        { id: 'analysis', label: '분석 근거', icon: 'fa-solid fa-magnifying-glass-chart' },
        { id: 'formula', label: '계산식', icon: 'fa-solid fa-calculator' },
    ];

    // ── 모델 표시 정보 ──
    public modelInfo: any = {
        'gemini-2.5-flash': { short: 'Gem 2.5 Flash', vendor: 'Google', tier: 'Flash', color: '#4285F4' },
        'gemini-3-flash-preview': { short: 'Gem 3 Flash', vendor: 'Google', tier: 'Flash', color: '#34A853' },
        'gemini-3.1-flash-lite-preview': { short: 'Gem 3.1 Lite', vendor: 'Google', tier: 'Flash Lite', color: '#FBBC05' },
        'gemini-3.1-pro-preview': { short: 'Gem 3.1 Pro', vendor: 'Google', tier: 'Pro', color: '#EA4335' },
        'gpt-5.4-2026-03-05': { short: 'GPT-5.4', vendor: 'OpenAI', tier: 'Full', color: '#10A37F' },
        'gpt-5.4-mini-2026-03-17': { short: 'GPT-5.4 Mini', vendor: 'OpenAI', tier: 'Mini', color: '#74AA9C' },
        'gpt-5.4-nano-2026-03-17': { short: 'GPT-5.4 Nano', vendor: 'OpenAI', tier: 'Nano', color: '#9EDCC5' },
    };

    // ── DPI 표시 정보 ──
    public dpiInfo: any = {
        150: { label: '저해상도', desc: '빠른 처리, 최소 비용. 텍스트 위주 문서에 적합', color: '#94a3b8', tokens: 563, costFactor: '1.0x' },
        200: { label: '기본', desc: '표준 해상도. 일반 문서 처리의 기본값', color: '#64748b', tokens: 1000, costFactor: '1.8x' },
        300: { label: '인쇄 품질', desc: '인쇄 수준 해상도. 한자·세밀 문자 인식에 효과적', color: '#3b82f6', tokens: 2250, costFactor: '4.0x' },
        400: { label: '고해상도', desc: '고밀도 문서 처리. 작은 글자·주석 인식 향상', color: '#8b5cf6', tokens: 4000, costFactor: '7.1x' },
        500: { label: '초고해상도', desc: '초정밀 인식. 복잡한 레이아웃·밀집 한자에 유리', color: '#d946ef', tokens: 6250, costFactor: '11.1x' },
        600: { label: '최대 해상도', desc: '최고 품질. 비용 대비 품질 향상 한계 검증용', color: '#dc2626', tokens: 9000, costFactor: '16.0x' },
    };

    // ── PDF 파일 특징 ──
    public fileInfo: any = {
        '견비통 (진료지침)': {
            type: '진료지침',
            desc: '한의표준임상진료지침으로 KCD 코드 분류표, PICO 기반 임상질문 표, 건강보험 통계표 등 구조화된 표가 다수 포함된 문서',
            icon: 'fa-solid fa-book-medical',
            tags: ['표/차트 다수', '한·중·일 혼재', '통계 데이터'],
            chars: '15,042자',
            cjk: '한자 275자 (2%)',
        },
        '상한론정해 (교과서)': {
            type: '교과서',
            desc: '상한론 원문(고전 한문)과 교감·해석·개요를 병기한 한의학 교과서. 전체의 46%가 한자로 구성',
            icon: 'fa-solid fa-graduation-cap',
            tags: ['고전 한문 중심', '한자 46%', '원문+해석 병기'],
            chars: '12,278자',
            cjk: '한자 5,632자 (46%)',
        },
        '대전대 (학술논문)': {
            type: '학술논문',
            desc: '대전대학교 한의학연구소 논문집 수록 학술논문. 2단(column) 레이아웃에 한자 비율 39%, 각주·참고문헌 포함',
            icon: 'fa-solid fa-file-lines',
            tags: ['2단 레이아웃', '한자 39%', '각주/참고문헌'],
            chars: '18,171자',
            cjk: '한자 6,999자 (39%)',
        },
        '한방병리 (초록하드)': {
            type: '초록하드',
            desc: '한방 처방 초록 모음으로 거의 전부가 한자(91%). 약재명·처방·용량이 밀집된 고난도 OCR 대상 문서',
            icon: 'fa-solid fa-microscope',
            tags: ['한자 91%', '밀집 텍스트', '처방/약재 나열'],
            chars: '5,612자',
            cjk: '한자 5,110자 (91%)',
        },
    };

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadConfig();
        await this.loadStatus();
        await this.loadResults();
        this.loading = false;
        await this.service.render();
    }

    // ── 데이터 로드 ──

    private async loadConfig() {
        const res = await wiz.call('get_config');
        if (res.code === 200) {
            this.models = res.data.models;
            this.dpis = res.data.dpis;
            this.files = res.data.files;
            this.pricing = res.data.pricing;
        }
    }

    private async loadStatus() {
        const res = await wiz.call('get_status');
        if (res.code === 200) {
            this.status = res.data;
        }
    }

    public async loadResults() {
        const res = await wiz.call('load_results');
        if (res.code === 200) {
            this.results = res.data;
            this._statsCache = null;
            this._analysisCache = null;
        }
        await this.service.render();
    }

    // ── 네비게이션 ──

    public async scrollTo(sectionId: string) {
        this.activeSection = sectionId;
        const el = document.getElementById('section-' + sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        await this.service.render();
    }

    public async selectFile(index: number) {
        this.activeFileIndex = index;
        await this.service.render();
    }

    // ── 축 전환 ──

    public async toggleCompareAxis(axis: string) {
        this.compareAxis = axis;
        await this.service.render();
    }

    public async toggleMatrixAxis(axis: string) {
        this.matrixAxis = axis;
        await this.service.render();
    }

    // ── PDF 모달 ──

    public async openPdf(file: any) {
        const appId = 'page.set';
        const url = `/wiz/api/${appId}/view_pdf?name=${encodeURIComponent(file.name)}`;
        this.pdfModalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.pdfModalLabel = file.label;
        this.pdfModalOpen = true;
        await this.service.render();
    }

    public async closePdfModal() {
        this.pdfModalOpen = false;
        await this.service.render();
    }

    // ── 가중치 ──

    public async applyPreset(preset: any) {
        this.weightQuality = preset.q;
        this.weightCost = preset.c;
        this.weightTime = preset.t;
        this._statsCache = null;
        await this.service.render();
    }

    public async onWeightChange() {
        this._statsCache = null;
        await this.service.render();
    }

    public weightSum(): number {
        return this.weightQuality + this.weightCost + this.weightTime;
    }

    // ── DPI 유틸 ──

    public getDpiLabel(dpi: number): string {
        return this.dpiInfo[dpi]?.label || `${dpi}DPI`;
    }

    public getDpiDesc(dpi: number): string {
        return this.dpiInfo[dpi]?.desc || '';
    }

    public getDpiColor(dpi: number): string {
        return this.dpiInfo[dpi]?.color || '#64748b';
    }

    public getDpiTokens(dpi: number): number {
        return this.dpiInfo[dpi]?.tokens || 0;
    }

    public getDpiCostFactor(dpi: number): string {
        return this.dpiInfo[dpi]?.costFactor || '';
    }

    public getDpiBarWidth(dpi: number): number {
        const maxTokens = 9000;
        return Math.round((this.getDpiTokens(dpi) / maxTokens) * 100);
    }

    // ── 스코어 계산 ──

    public getFileResult(fileKey: string, model: string, dpi: number): any {
        const fileData = this.results[fileKey];
        if (!fileData || !fileData.models || !fileData.models[model]) return null;
        return fileData.models[model][String(dpi)] || null;
    }

    public getWeightedScore(model: string, dpi: number): number | null {
        const fileKeys = Object.keys(this.results);
        if (fileKeys.length === 0) return null;

        let totalQuality = 0, totalCost = 0, totalTime = 0, count = 0;

        for (const key of fileKeys) {
            const r = this.getFileResult(key, model, dpi);
            if (!r) return null;
            totalQuality += r.quality;
            totalCost += r.cost;
            totalTime += r.time;
            count++;
        }

        if (count === 0) return null;

        const avgQuality = totalQuality / count;
        const avgCost = totalCost / count;
        const avgTime = totalTime / count;

        return this.calculateScore(avgQuality, avgCost, avgTime);
    }

    private calculateScore(quality: number, cost: number, time: number): number {
        const stats = this.getGlobalStats();
        if (!stats) return 0;

        const normQuality = quality;  // F1 절대값 사용 (0~1)

        const normCost = stats.maxCost === stats.minCost ? 1 :
            1 - (cost - stats.minCost) / (stats.maxCost - stats.minCost);

        let normTime: number;
        if (time <= 0) {
            normTime = 0.5;
        } else {
            normTime = stats.maxTime === stats.minTime ? 1 :
                1 - (time - stats.minTime) / (stats.maxTime - stats.minTime);
        }

        const wQ = this.weightQuality / 100;
        const wC = this.weightCost / 100;
        const wT = this.weightTime / 100;

        return Math.round((normQuality * wQ + normCost * wC + normTime * wT) * 10000) / 100;
    }

    private _statsCache: any = null;
    public getGlobalStats(): any {
        if (this._statsCache) return this._statsCache;

        const fileKeys = Object.keys(this.results);
        if (fileKeys.length === 0) return null;

        let qualities: number[] = [], costs: number[] = [], times: number[] = [];

        for (const model of this.models) {
            for (const dpi of this.dpis) {
                let q = 0, c = 0, t = 0, n = 0;
                for (const key of fileKeys) {
                    const r = this.getFileResult(key, model, dpi);
                    if (r) {
                        q += r.quality;
                        c += r.cost;
                        t += r.time;
                        n++;
                    }
                }
                if (n > 0) {
                    qualities.push(q / n);
                    costs.push(c / n);
                    const avgTime = t / n;
                    if (avgTime > 0) {
                        times.push(avgTime);
                    }
                }
            }
        }

        if (qualities.length === 0) return null;

        this._statsCache = {
            minQuality: Math.min(...qualities), maxQuality: Math.max(...qualities),
            minCost: Math.min(...costs), maxCost: Math.max(...costs),
            minTime: times.length > 0 ? Math.min(...times) : 0,
            maxTime: times.length > 0 ? Math.max(...times) : 0,
        };
        return this._statsCache;
    }

    // ── 종합 랭킹 ──

    public getRanking(): any[] {
        const ranking: any[] = [];

        for (const model of this.models) {
            for (const dpi of this.dpis) {
                const score = this.getWeightedScore(model, dpi);
                if (score === null) continue;

                const fileKeys = Object.keys(this.results);
                let totalQ = 0, totalC = 0, totalT = 0, n = 0;
                for (const key of fileKeys) {
                    const r = this.getFileResult(key, model, dpi);
                    if (r) {
                        totalQ += r.quality;
                        totalC += r.cost;
                        totalT += r.time;
                        n++;
                    }
                }

                ranking.push({
                    model,
                    dpi,
                    score,
                    avgQuality: n > 0 ? Math.round(totalQ / n * 10000) / 100 : 0,
                    avgCost: n > 0 ? Math.round(totalC / n * 1000000) / 1000000 : 0,
                    avgTime: n > 0 ? Math.round(totalT / n * 10) / 10 : 0,
                    hasTimeData: n > 0 && (totalT / n) > 0,
                });
            }
        }

        ranking.sort((a, b) => b.score - a.score);
        return ranking;
    }

    // ── 분석 데이터 ──

    private _analysisCache: any = null;

    public getAnalysisData(): any {
        if (this._analysisCache) return this._analysisCache;

        const fileKeys = Object.keys(this.results);
        if (fileKeys.length === 0) return null;

        // 모델별 전체 평균
        const modelAvgs: any = {};
        for (const model of this.models) {
            let totalQ = 0, count = 0;
            for (const dpi of this.dpis) {
                for (const key of fileKeys) {
                    const r = this.getFileResult(key, model, dpi);
                    if (r) { totalQ += r.quality; count++; }
                }
            }
            modelAvgs[model] = count > 0 ? Math.round(totalQ / count * 1000) / 10 : 0;
        }

        // 모델별 파일별 평균 (DPI 전체 평균)
        const modelFileAvgs: any = {};
        for (const model of this.models) {
            modelFileAvgs[model] = {};
            for (const key of fileKeys) {
                let totalQ = 0, count = 0;
                for (const dpi of this.dpis) {
                    const r = this.getFileResult(key, model, dpi);
                    if (r) { totalQ += r.quality; count++; }
                }
                modelFileAvgs[model][key] = count > 0 ? Math.round(totalQ / count * 1000) / 10 : 0;
            }
        }

        // DPI별 전체 평균
        const dpiAvgs: any = {};
        for (const dpi of this.dpis) {
            let totalQ = 0, count = 0;
            for (const model of this.models) {
                for (const key of fileKeys) {
                    const r = this.getFileResult(key, model, dpi);
                    if (r) { totalQ += r.quality; count++; }
                }
            }
            dpiAvgs[dpi] = count > 0 ? Math.round(totalQ / count * 1000) / 10 : 0;
        }

        // DPI별 파일별 평균 (모델 전체 평균)
        const dpiFileAvgs: any = {};
        for (const dpi of this.dpis) {
            dpiFileAvgs[dpi] = {};
            for (const key of fileKeys) {
                let totalQ = 0, count = 0;
                for (const model of this.models) {
                    const r = this.getFileResult(key, model, dpi);
                    if (r) { totalQ += r.quality; count++; }
                }
                dpiFileAvgs[dpi][key] = count > 0 ? Math.round(totalQ / count * 1000) / 10 : 0;
            }
        }

        // Google vs OpenAI 그룹 평균
        const googleModels = this.models.filter(m => m.startsWith('gemini'));
        const openaiModels = this.models.filter(m => m.startsWith('gpt'));
        const vendorAvg = (arr: string[]) => {
            let total = 0, count = 0;
            for (const m of arr) { total += modelAvgs[m]; count++; }
            return count > 0 ? Math.round(total / count * 10) / 10 : 0;
        };

        // 모델 순위
        const modelRanking = [...this.models].sort((a, b) => modelAvgs[b] - modelAvgs[a]);
        const topModel = modelRanking[0];
        const secondModel = modelRanking[1];
        const lastModel = modelRanking[modelRanking.length - 1];
        const topGap = Math.round((modelAvgs[topModel] - modelAvgs[secondModel]) * 10) / 10;
        const topLastGap = Math.round((modelAvgs[topModel] - modelAvgs[lastModel]) * 10) / 10;

        // 파일별 best DPI
        const fileBestDpi: any = {};
        for (const key of fileKeys) {
            let bestDpi = this.dpis[0], bestAvg = 0;
            for (const dpi of this.dpis) {
                if (dpiFileAvgs[dpi][key] > bestAvg) {
                    bestAvg = dpiFileAvgs[dpi][key];
                    bestDpi = dpi;
                }
            }
            fileBestDpi[key] = { dpi: bestDpi, avg: bestAvg };
        }

        // DPI 최적 구간
        const dpiEntries = this.dpis.map(d => ({ dpi: d, avg: dpiAvgs[d] }));
        dpiEntries.sort((a, b) => b.avg - a.avg);
        const bestDpi = dpiEntries[0];
        const dpi600 = dpiAvgs[600] || 0;
        const dpi200 = dpiAvgs[200] || 0;
        const dpiDelta600vs200 = Math.round((dpi600 - dpi200) * 10) / 10;

        this._analysisCache = {
            modelAvgs, modelFileAvgs, dpiAvgs, dpiFileAvgs,
            googleAvg: vendorAvg(googleModels),
            openaiAvg: vendorAvg(openaiModels),
            modelRanking, topModel, secondModel, lastModel,
            topGap, topLastGap,
            fileBestDpi, bestDpi,
            dpi600, dpi200, dpiDelta600vs200,
        };
        return this._analysisCache;
    }

    public getModelAvgQuality(model: string): number {
        const data = this.getAnalysisData();
        return data ? data.modelAvgs[model] || 0 : 0;
    }

    public getDpiAvgQuality(dpi: number): number {
        const data = this.getAnalysisData();
        return data ? data.dpiAvgs[dpi] || 0 : 0;
    }

    public getBestDpiForModel(model: string): number {
        let bestDpi = this.dpis[0];
        let bestAvg = 0;
        for (const dpi of this.dpis) {
            const fileKeys = Object.keys(this.results);
            let totalQ = 0, count = 0;
            for (const key of fileKeys) {
                const r = this.getFileResult(key, model, dpi);
                if (r) { totalQ += r.quality; count++; }
            }
            const avg = count > 0 ? totalQ / count : 0;
            if (avg > bestAvg) { bestAvg = avg; bestDpi = dpi; }
        }
        return bestDpi;
    }

    // ── 유틸 ──

    public getModelShort(model: string): string {
        return this.modelInfo[model]?.short || model;
    }

    public getModelColor(model: string): string {
        return this.modelInfo[model]?.color || '#666';
    }

    public getModelVendor(model: string): string {
        return this.modelInfo[model]?.vendor || '';
    }

    public getModelTier(model: string): string {
        return this.modelInfo[model]?.tier || '';
    }

    public getFileType(label: string): string {
        return this.fileInfo[label]?.type || '';
    }

    public getFileDesc(label: string): string {
        return this.fileInfo[label]?.desc || '';
    }

    public getFileIcon(label: string): string {
        return this.fileInfo[label]?.icon || 'fa-solid fa-file-pdf';
    }

    public getFileTags(label: string): string[] {
        return this.fileInfo[label]?.tags || [];
    }

    public getFileChars(label: string): string {
        return this.fileInfo[label]?.chars || '';
    }

    public getFileCjk(label: string): string {
        return this.fileInfo[label]?.cjk || '';
    }

    public qualityColor(q: number): string {
        if (q >= 0.85) return 'text-emerald-700 bg-emerald-50';
        if (q >= 0.75) return 'text-blue-700 bg-blue-50';
        if (q >= 0.65) return 'text-amber-700 bg-amber-50';
        return 'text-red-700 bg-red-50';
    }

    public scoreColor(s: number): string {
        if (s >= 80) return 'bg-emerald-600';
        if (s >= 60) return 'bg-blue-600';
        if (s >= 40) return 'bg-amber-500';
        return 'bg-red-500';
    }

    public scoreCellStyle(score: number | null): any {
        if (score === null) return { background: '#f8fafc', color: '#94a3b8' };
        if (score >= 80) return { background: '#dcfce7', color: '#166534' };
        if (score >= 60) return { background: '#dbeafe', color: '#1e40af' };
        if (score >= 40) return { background: '#fef3c7', color: '#92400e' };
        return { background: '#fee2e2', color: '#991b1b' };
    }

    public formatScore(model: string, dpi: number): string {
        const score = this.getWeightedScore(model, dpi);
        return score !== null ? score.toFixed(1) : '-';
    }

    public rankBadge(rank: number): string {
        if (rank === 1) return '🥇';
        if (rank === 2) return '🥈';
        if (rank === 3) return '🥉';
        return `#${rank}`;
    }

    public hasAnyResults(): boolean {
        return this.status.done > 0;
    }

    public getCompletionPercent(): number {
        if (this.status.total === 0) return 0;
        return Math.round(this.status.done / this.status.total * 100);
    }

    public formatCost(cost: number): string {
        if (cost < 0.001) return '<$0.001';
        return '$' + cost.toFixed(4);
    }

    public formatTime(seconds: number): string {
        if (seconds <= 0) return '-';
        if (seconds < 60) return seconds.toFixed(1) + 's';
        return (seconds / 60).toFixed(1) + 'min';
    }

    public getActiveFileKey(): string {
        if (this.files.length === 0) return '';
        return this.files[this.activeFileIndex]?.name || '';
    }

    public getActiveFileLabel(): string {
        if (this.files.length === 0) return '';
        return this.files[this.activeFileIndex]?.label || '';
    }

    public getFileQualityPercent(fileKey: string, model: string, dpi: number): string {
        const r = this.getFileResult(fileKey, model, dpi);
        if (!r) return '-';
        return (r.quality * 100).toFixed(1) + '%';
    }
}

export default PageSetComponent;